var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "siteDetail" } },
    [
      _vm.loading
        ? _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                height: "100vh",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
              },
            },
            [
              _c(
                "div",
                [
                  _c("md-progress-spinner", {
                    staticClass: "md-accent text-light",
                    attrs: { "md-diameter": 30, "md-mode": "indeterminate" },
                  }),
                ],
                1
              ),
            ]
          )
        : _c("div", [
            _c(
              "div",
              {
                staticClass: "header",
                staticStyle: { height: "75px", background: "#031529" },
              },
              [
                _c("span", [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.$t("message.siteAddress")) +
                        " :\n                    "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://" + _vm.site.siteAddress,
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(_vm.site.siteAddress))]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  [
                    _c(
                      "a-button",
                      {
                        staticClass: "btn btn primary",
                        attrs: { id: "turn-back" },
                        on: {
                          click: function ($event) {
                            return _vm.turnBackToTheSites()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("message.turnBack"))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.createdDate")) +
                        " : " +
                        _vm._s(_vm.createdTime()) +
                        "\n                "
                    ),
                    _c(
                      "a-button",
                      {
                        staticClass: "bg-dark border-dark text-light",
                        on: {
                          click: function ($event) {
                            return _vm.edit(_vm.site._id)
                          },
                        },
                      },
                      [_c("ActionEdit")],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                {
                  staticClass: "left",
                  staticStyle: {
                    width: "15%",
                    background: "#1e1e2d !important",
                  },
                },
                [
                  _c(
                    "a-menu",
                    {
                      staticClass: "h-100 w-100",
                      attrs: {
                        "default-selected-keys": _vm.selectedPage,
                        mode: "vertical",
                        theme: "dark",
                      },
                      model: {
                        value: _vm.selectedPage,
                        callback: function ($$v) {
                          _vm.selectedPage = $$v
                        },
                        expression: "selectedPage",
                      },
                    },
                    [
                      _c(
                        "a-menu-item",
                        { key: "dashboard" },
                        [
                          _c("a-icon", { attrs: { type: "dashboard" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Dashboard")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "agents" },
                        [
                          _c("a-icon", { attrs: { type: "customer-service" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Agents")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "integration" },
                        [
                          _c("a-icon", {
                            attrs: { type: "safety-certificate" },
                          }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Integration")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "settings" },
                        [
                          _c("a-icon", { attrs: { type: "setting" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Settings")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "contacts" },
                        [
                          _c("a-icon", { attrs: { type: "link" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.Contacts")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "invoices" },
                        [
                          _c("a-icon", { attrs: { type: "gold" } }),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("billing.invoices")) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "planManagment" },
                        [
                          _c("a-icon", { attrs: { type: "fire" } }),
                          _vm._v(
                            "\n                        Plan Yönetimi\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "welcomeSupsis" },
                        [
                          _c("a-icon", { attrs: { type: "form" } }),
                          _vm._v(
                            "\n                        Welcome Supsis\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-menu-item",
                        { key: "demoForm" },
                        [
                          _c("a-icon", { attrs: { type: "form" } }),
                          _vm._v(
                            "\n                        Demo Formu\n                    "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right", staticStyle: { width: "85%" } },
                [
                  _c(
                    "a-card",
                    {
                      style: [
                        _vm.selectedPage.includes("planManagment") && {
                          background: "rgb(248, 249, 250)",
                        },
                      ],
                    },
                    [
                      _vm.selectedPage.includes("dashboard")
                        ? _c(
                            "div",
                            [
                              _c("SiteDetailDashboard", {
                                attrs: {
                                  site: _vm.site,
                                  enable: _vm.enable,
                                  suspend: _vm.suspend,
                                  blink: _vm.blink,
                                  "payment-method": _vm.paymentMethod,
                                  "trial-day": _vm.trialDay,
                                  "whatsapp-wallet": _vm.whatsappWallet,
                                  "max-low-balance": _vm.maxLowBalance,
                                  "gupshup-commission": _vm.gupshupCommission,
                                  "whatsapp-commission": _vm.whatsappCommission,
                                  "total-discount": _vm.totalDiscount,
                                  "monthly-mail-send-limit":
                                    _vm.monthlyMailSendLimit,
                                  "ai-usage-commission": _vm.aiUsageCommission,
                                  "ai-call-commission": _vm.aiCallCommission,
                                  "vat-rate": _vm.vatRate,
                                  "invoice-due-days": _vm.invoiceDueDays,
                                  balance: _vm.balance,
                                },
                                on: {
                                  "update:enable": function ($event) {
                                    _vm.enable = $event
                                  },
                                  "update:suspend": function ($event) {
                                    _vm.suspend = $event
                                  },
                                  "update:blink": function ($event) {
                                    _vm.blink = $event
                                  },
                                  "update:paymentMethod": function ($event) {
                                    _vm.paymentMethod = $event
                                  },
                                  "show-trial-prompt": _vm.showTrialPrompt,
                                  "show-total-discount-prompt":
                                    _vm.showTotalDiscountPrompt,
                                  "show-whatsapp-wallet-prompt":
                                    _vm.showWhasappWalletPrompt,
                                  "show-whatsapp-low-limit-prompt":
                                    _vm.showWhasappLowLimitPrompt,
                                  "show-monthly-mail-send-limit-prompt":
                                    _vm.showMonthlyMailSendLimitPrompt,
                                  "show-gupshup-commission-prompt":
                                    _vm.showGupshupCommissionPrompt,
                                  "show-whatsapp-commission-prompt":
                                    _vm.showWhatsappCommissionPrompt,
                                  "show-openai-commission-prompt":
                                    _vm.showOpenAICommissionPrompt,
                                  "show-ai-call-commission-prompt":
                                    _vm.showAiCallCommissionPrompt,
                                  "show-vat-rate-prompt": _vm.showVatRatePrompt,
                                  "show-invoice-due-days-prompt":
                                    _vm.showInvoiceDueDaysPrompt,
                                  "delete-site": _vm.del,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("agents")
                        ? _c(
                            "div",
                            [
                              _c("UserList", {
                                attrs: { "site-id": _vm.site._id },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("integration")
                        ? _c("div", [
                            _vm._v(_vm._s(_vm.$t("message.integration"))),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("settings")
                        ? _c("div", [_vm._v(_vm._s(_vm.$t("message.setting")))])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("invoices")
                        ? _c(
                            "div",
                            [
                              _c("InvoiceList", {
                                attrs: {
                                  "initial-data": _vm.site,
                                  "site-address": _vm.site.clientAddress,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("contacts")
                        ? _c("div", [
                            _c("div", { staticClass: "box-container" }, [
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("billing.ownerName"))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.site.rootUserName) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "box" }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("billing.ownerEmailAddress"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.site.rootUserEmail) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("planManagment")
                        ? _c("div", { staticClass: "plans-page" }, [
                            _vm.showingBillingPlans
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "material-icons go-back-button",
                                        on: { click: _vm.goBack },
                                      },
                                      [_vm._v("arrow_back")]
                                    ),
                                    _vm._v(" "),
                                    _c("CustomerPlans", {
                                      attrs: {
                                        "is-admin": true,
                                        "site-id": _vm.site._id,
                                        "site-appsumo-coupons":
                                          _vm.site.appsumoCoupons,
                                        "site-current-plans": _vm.currentPlans,
                                        "site-plans": _vm.plans,
                                        type: _vm.showingBillingPlans,
                                      },
                                      on: { "go-back": _vm.goBack },
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _c(
                                      "a-modal",
                                      {
                                        attrs: {
                                          visible: _vm.deleteItem,
                                          icon: "exclamation-circle",
                                          title: "Delete Package",
                                        },
                                        on: {
                                          cancel: function ($event) {
                                            _vm.deleteItem = null
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "footer",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "a-button",
                                                    {
                                                      key: "back",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.deleteItem = null
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chatbotv2.dismiss"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a-button",
                                                    {
                                                      key: "submit",
                                                      attrs: { type: "danger" },
                                                      on: {
                                                        click:
                                                          _vm.deletePackage,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chatbotv2.delete"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          2180623913
                                        ),
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "Bu paketi silmek istediğinizden eminmisiniz kalıcı olarak silinecektir."
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.modalShowing
                                      ? _c("CreateNewPlanModal", {
                                          on: {
                                            cancel: function ($event) {
                                              _vm.modalShowing = false
                                            },
                                            create: _vm.createNewPlan,
                                            update: _vm.planUpdate,
                                          },
                                          model: {
                                            value: _vm.form,
                                            callback: function ($$v) {
                                              _vm.form = $$v
                                            },
                                            expression: "form",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "header-top" }, [
                                      _c("div", { staticClass: "title" }, [
                                        _vm._v("Mevcut Planlar"),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("CurrentPlans", {
                                      class: "current-plans",
                                      attrs: {
                                        "site-id": _vm.site._id,
                                        "site-current-plans": _vm.currentPlans,
                                        "site-plans": _vm.plans,
                                      },
                                      on: { show: _vm.showPlans },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "header-plans-top" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "create-plan",
                                            on: {
                                              click: function ($event) {
                                                _vm.modalShowing = true
                                              },
                                            },
                                          },
                                          [_vm._v("Plan Oluştur")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      Object.keys(_vm.groupedPlans),
                                      function (planName) {
                                        return _c(
                                          "div",
                                          { staticClass: "plan-container" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "plan-title" },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      planName
                                                        .split("-")
                                                        .map(function (c) {
                                                          return (
                                                            c[0].toUpperCase() +
                                                            c
                                                              .slice(1)
                                                              .toLowerCase()
                                                          )
                                                        })
                                                        .join(" ")
                                                    ) +
                                                    "\n                                    Paketleri\n                                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "plan-items-wrapper",
                                              },
                                              [
                                                _c(
                                                  "transition",
                                                  { attrs: { name: "scale" } },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.groupedPlans[
                                                                planName
                                                              ].length > 4,
                                                            expression:
                                                              "groupedPlans[planName].length > 4",
                                                          },
                                                        ],
                                                        attrs: {
                                                          id: "prev-button",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "md-icon",
                                                          {
                                                            staticClass:
                                                              "navigate-arrow navigate-left",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "arrow_back_ios_new\n                                            "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "plan-items" },
                                                  _vm._l(
                                                    _vm.groupedPlans[planName],
                                                    function (item) {
                                                      return _c("Card", {
                                                        key: item._id,
                                                        staticClass: "plan",
                                                        attrs: {
                                                          plan: item,
                                                          "editable-card": true,
                                                          "self-site": true,
                                                          visibilityDetails:
                                                            _vm.site
                                                              .visibilityPlanSettings,
                                                        },
                                                        on: {
                                                          "edit-action":
                                                            function ($event) {
                                                              return _vm.editPlan(
                                                                item
                                                              )
                                                            },
                                                          "delete-action":
                                                            function ($event) {
                                                              _vm.deleteItem =
                                                                item
                                                            },
                                                          visibilityChanged:
                                                            _vm.visibilityChange,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "transition",
                                                  { attrs: { name: "scale" } },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.groupedPlans[
                                                                planName
                                                              ].length > 4,
                                                            expression:
                                                              "groupedPlans[planName].length > 4",
                                                          },
                                                        ],
                                                        attrs: {
                                                          id: "next-button",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "md-icon",
                                                          {
                                                            staticClass:
                                                              "navigate-arrow navigate-right",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "arrow_forward_ios\n                                            "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("demoForm")
                        ? _c(
                            "div",
                            [
                              _c("DemoFormViews", {
                                attrs: {
                                  "site-id": _vm.site._id,
                                  "site-data": _vm.site,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedPage.includes("welcomeSupsis")
                        ? _c(
                            "div",
                            [
                              _c("WelcomeSupsisViews", {
                                attrs: {
                                  "site-id": _vm.site._id,
                                  "site-data": _vm.site,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
      _vm._v(" "),
      _c("SiteCreateModalForm", {
        attrs: {
          "edit-mode": true,
          "on-cancel": _vm.onModalFormCancel,
          "on-success": _vm.onModalFormSuccess,
          "updating-site": _vm.updatingSite,
          visible: _vm.modalVisible,
          "is-modal-show": _vm.isNewModal,
          "close-modal": _vm.hideNewModalForm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }